import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";
import { useBoard } from "../../../providers/BoardDetailProvider";
import ImageSlider from "../../molecules/ImageSlider";

const BoardBodySlider = () => {
  const {
    state: { boardDetailData },
  } = useBoard();

  const { image_urls = [] } = boardDetailData ?? {};

  return <ImageSlider className={STBoardDetail} imageUrls={image_urls} />;
};

export default BoardBodySlider;
